export default "__VITE_ASSET__CRzp91$Y__";